
import React, { Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import isEmpty from 'lodash/isEmpty';
import isNaN from 'lodash/isNaN';

import parseFloatCz from '../common/parseFloatCz';

let resolve;

const classNames = mergeStyleSets({
    dialogContent: {
    },
    title: {
        width: 150
    },
    count: {
        width: 100
    }
});

const DialogContent = ({operation, title, price, onChange}) => {

    const handleChange = (e, name) => {
        if (onChange) {
            onChange(name, e.target.value);
        }
    }

    return (
        <div className={classNames.dialogContent}>
            <Stack tokens={{childrenGap: 8}}>
                <TextField
                    label="Operace"
                    value={operation.title}
                    readOnly={true}
                />
                <TextField
                    label="Název položky"
                    value={title}
                    onChange={e => handleChange(e, 'title')}
                />
                <TextField
                    label="Cena položky (Kč)"
                    value={price}
                    onChange={e => handleChange(e, 'price')}
                />
            </Stack>
        </div>
    );
}

class DialogEditOperationItem extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogEditOperationItem />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            operation: null,
            title: '',
            price: 0.0,
            allowDelete: false
        };
    }

    checkValues() {
        let warnings = [];
        if (isEmpty(this.state.title)) {
            warnings.push('Není zadaný název položky ceníku');
        }
        if (isNaN(parseFloat(this.state.price))) {
            warnings.push('Není zadaná cena položky ceníku');
        }
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                result: 'OK',
                opId: this.state.operation.id,
                title: this.state.title,
                price: parseFloatCz(this.state.price)
            });
        }
    }

    handleChange = (name, value) => {
        this.setState({
            [name]: value
        });
    }

    handleDelete = () => {
        this.setState({hidden: true});
        resolve({
            result: 'DELETE'
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Položka ceníku"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        operation={this.state.operation}
                        title={this.state.title}
                        price={this.state.price}
                        onChange={this.handleChange}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Uložit" disabled={!this.checkValues()} />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                    {this.state.allowDelete && <DefaultButton onClick={this.handleDelete} text="Smazat položku ceníku" />}
                </DialogFooter>
            </Dialog>
        );
    }

    show(operation, title, price, allowDelete) {
        this.setState({
            hidden: false,
            operation: operation,
            title: title,
            price: price,
            allowDelete: (allowDelete === true)
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogEditOperationItem.create();
